var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import rtbScallopedImageEnergizingNutritionSrc from '@images/marketing/NTTDelicious-EnergizingNutrition.jpg';
import rtbScallopedImageEnrichingVarietySrc from '@images/marketing/NTTDelicious-EnrichingVariety.jpg';
import rtbScallopedImageEnticingTasteSrc from '@images/marketing/NTTDelicious-EnticingTaste.jpg';
import { ProbioticName, TreatName } from '@marketing/content';
import { RTBColor, RTBIconName } from '../Icons';
import { RTBBackgroundColor } from '../RTBWithIcons';
export var rtbWithImagesSectionContent = {
    buttonLabel: 'Explore Meals',
    ctaUrl: '/meals',
    tickerText: 'nose-to-tail delicious',
    rtbItems: [
        {
            imageData: {
                src: rtbScallopedImageEnticingTasteSrc,
                alt: 'Enticing Taste',
            },
            headline: 'Enticing Taste',
            subhead: 'A stimulating mix of vibrant ingredients, savory smells and tantalizing textures.',
        },
        {
            imageData: {
                src: rtbScallopedImageEnrichingVarietySrc,
                alt: 'Enriching Variety',
            },
            headline: 'Enriching Variety',
            subhead: 'A diverse diet that makes mealtime endlessly interesting.',
        },
        {
            imageData: {
                src: rtbScallopedImageEnergizingNutritionSrc,
                alt: 'Energizing Nutrition',
            },
            headline: 'Energizing Nutrition',
            subhead: 'Vet-developed for the complete and balanced nutrition dogs need.',
        },
    ],
};
var treatsTickerText = 'chew on this';
var probioticsTickerText = 'gut instincts';
var allRTBIconItemContent = (_a = {},
    _a[RTBIconName.CHICKEN] = {
        description: 'Made from 100% chicken',
        iconName: RTBIconName.CHICKEN,
    },
    _a[RTBIconName.NO_PIPET] = {
        description: 'No artificial colors, flavors, fillers or funky stuff',
        iconName: RTBIconName.NO_PIPET,
    },
    _a[RTBIconName.PAW_HEART] = {
        description: 'A rawhide alternative',
        iconName: RTBIconName.PAW_HEART,
    },
    _a[RTBIconName.DOG] = {
        description: 'Break into pieces for training or use as a meal topper',
        iconName: RTBIconName.DOG,
    },
    _a[RTBIconName.COW] = {
        description: 'Made from 100% beef',
        iconName: RTBIconName.COW,
    },
    _a[RTBIconName.LEAF] = {
        description: 'A good source of fiber',
        iconName: RTBIconName.LEAF,
    },
    _a[RTBIconName.SWEET_POTATO] = {
        description: 'Made from 100% sweet potato',
        iconName: RTBIconName.SWEET_POTATO,
    },
    _a[RTBIconName.GUT] = {
        description: 'Helps promote a healthy microflora to support stool quality and digestive health',
        iconName: RTBIconName.GUT,
    },
    _a[RTBIconName.BACTERIA] = {
        description: 'Contains 20 billion CFUs and 7 full spectrum probiotic strains per serving',
        iconName: RTBIconName.BACTERIA,
    },
    _a[RTBIconName.PHARMACY] = {
        description: 'Made at FDA registered facilities with each batch tested for integrity',
        iconName: RTBIconName.PHARMACY,
    },
    _a);
export var rtbWithIconsSectionContent = (_b = {},
    _b[TreatName.BeefJerky] = {
        tickerText: treatsTickerText,
        theme: 'dark',
        backgroundColor: RTBBackgroundColor.DARK_RED,
        rtbItems: [RTBIconName.COW, RTBIconName.NO_PIPET, RTBIconName.PAW_HEART, RTBIconName.DOG].map(function (iconName) { return (__assign(__assign({}, allRTBIconItemContent[iconName]), { theme: 'dark', iconTheme: 'light', backgroundColor: RTBColor.PINK })); }),
    },
    _b[TreatName.ChickenJerky] = {
        tickerText: treatsTickerText,
        theme: 'dark',
        backgroundColor: RTBBackgroundColor.BROWN,
        rtbItems: [
            RTBIconName.CHICKEN,
            RTBIconName.NO_PIPET,
            RTBIconName.PAW_HEART,
            RTBIconName.DOG,
        ].map(function (iconName) { return (__assign(__assign({}, allRTBIconItemContent[iconName]), { theme: 'dark', iconTheme: 'light', backgroundColor: RTBColor.SQUASH })); }),
    },
    _b[TreatName.BeefBlueberry] = {
        tickerText: treatsTickerText,
        theme: 'light',
        backgroundColor: RTBBackgroundColor.LIGHT_BLUE,
        rtbItems: [RTBIconName.COW, RTBIconName.LEAF, RTBIconName.NO_PIPET, RTBIconName.DOG].map(function (iconName) {
            var _a;
            var description = (_a = allRTBIconItemContent[iconName]) === null || _a === void 0 ? void 0 : _a.description;
            if (iconName === RTBIconName.COW) {
                description = 'Made with quality meat and fruit';
            }
            return __assign(__assign({}, allRTBIconItemContent[iconName]), { description: description, theme: 'light', iconTheme: 'dark', backgroundColor: RTBColor.BLUE });
        }),
    },
    _b[TreatName.ChickenCranberry] = {
        tickerText: treatsTickerText,
        theme: 'light',
        backgroundColor: RTBBackgroundColor.LIGHT_PINK,
        rtbItems: [RTBIconName.CHICKEN, RTBIconName.LEAF, RTBIconName.NO_PIPET, RTBIconName.DOG].map(function (iconName) {
            var _a;
            var description = (_a = allRTBIconItemContent[iconName]) === null || _a === void 0 ? void 0 : _a.description;
            if (iconName === RTBIconName.CHICKEN) {
                description = 'Made with quality meat and fruit';
            }
            return __assign(__assign({}, allRTBIconItemContent[iconName]), { description: description, theme: 'light', iconTheme: 'dark', backgroundColor: RTBColor.BACON });
        }),
    },
    _b[TreatName.SweetPotato] = {
        tickerText: treatsTickerText,
        theme: 'light',
        backgroundColor: RTBBackgroundColor.SQUASH,
        rtbItems: [
            RTBIconName.SWEET_POTATO,
            RTBIconName.LEAF,
            RTBIconName.NO_PIPET,
            RTBIconName.PAW_HEART,
        ].map(function (iconName) {
            var _a;
            var description = (_a = allRTBIconItemContent[iconName]) === null || _a === void 0 ? void 0 : _a.description;
            if (iconName === RTBIconName.LEAF) {
                description = 'Low in fat + a good source of fiber';
            }
            return __assign(__assign({}, allRTBIconItemContent[iconName]), { description: description, theme: 'light', iconTheme: 'light', backgroundColor: RTBColor.ORANGE });
        }),
    },
    _b[ProbioticName.FullSpectrum] = {
        tickerText: probioticsTickerText,
        theme: 'dark',
        backgroundColor: RTBBackgroundColor.DARK_BLUE,
        rtbItems: [RTBIconName.GUT, RTBIconName.PHARMACY, RTBIconName.BACTERIA, RTBIconName.LEAF].map(function (iconName) {
            var _a;
            var description = (_a = allRTBIconItemContent[iconName]) === null || _a === void 0 ? void 0 : _a.description;
            if (iconName === RTBIconName.LEAF) {
                description = 'With prebiotic fiber for added beneficial bacteria development';
            }
            return __assign(__assign({}, allRTBIconItemContent[iconName]), { description: description, theme: 'dark', iconTheme: 'light', backgroundColor: RTBColor.SQUASH });
        }),
    },
    _b[ProbioticName.GITargeted] = {
        tickerText: probioticsTickerText,
        theme: 'dark',
        backgroundColor: RTBBackgroundColor.GREEN,
        rtbItems: [RTBIconName.GUT, RTBIconName.PHARMACY, RTBIconName.BACTERIA, RTBIconName.LEAF].map(function (iconName) {
            var _a;
            var description = (_a = allRTBIconItemContent[iconName]) === null || _a === void 0 ? void 0 : _a.description;
            if (iconName === RTBIconName.LEAF) {
                description = 'With prebiotic fiber for added beneficial bacteria development';
            }
            if (iconName === RTBIconName.BACTERIA) {
                description =
                    'Contains 20 billion CFUs and 5 full spectrum probiotic strains per serving';
            }
            return __assign(__assign({}, allRTBIconItemContent[iconName]), { description: description, theme: 'dark', iconTheme: 'light', backgroundColor: RTBColor.SQUASH });
        }),
    },
    _b);
